import SchemaMarkup from "../Components/SchemaMarkup";

const TreatmentsCollectionSchema = ({ treatments }) => {
  if (!treatments || treatments.length === 0) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id": "https://msayurved.com/treatments/#collectionpage",
    "url": "https://msayurved.com/treatments/",
    "name": "Ayurvedic Treatments in Bhuj | Dr. Jigar Gor",
    "description":
      "Explore Ayurvedic treatments offered by Dr. Jigar Gor in Bhuj, Kutch, including personalized Ayurvedic care for hair, skin, joint, digestive, and other health concerns.",
    "isPartOf": {
      "@id": "https://msayurved.com/#website"
    },
    "about": {
      "@id": "https://msayurved.com/#medicalclinic"
    },
    "mainEntity": {
      "@type": "ItemList",
      "@id": "https://msayurved.com/treatments/#treatment-list",
      "name": "Ayurvedic Treatments",
      "numberOfItems": treatments.length,
      "itemListElement": treatments.map((treatment, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": treatment.title,
        "url": `https://msayurved.com/treatments/${treatment.slug}/`
      }))
    },
    "inLanguage": "en-IN"
  };

  return <SchemaMarkup data={schema} />;
};

export default TreatmentsCollectionSchema;